import { Dialog, Button, Flex, Heading } from '@buffer-mono/popcorn'

import { stringTokenizer } from '~publish/legacy/i18n'

import styles from './TrialCompleteModal.module.css'

export interface TrialCompleteModalProps {
  hasExpiredProTrial: boolean
  hasExpiredBusinessTrial: boolean
  isPremiumBusiness: boolean
  translations: {
    header: string
    completeAndUpgrade: string
    cancelTrial: string
  }
  cancelTrial: (...args: unknown[]) => unknown
  completeAndUpgrade: (...args: unknown[]) => unknown
}

const TrialCompleteModal = ({
  translations,
  hasExpiredProTrial,
  hasExpiredBusinessTrial,
  isPremiumBusiness,
  cancelTrial,
  completeAndUpgrade,
}: TrialCompleteModalProps): JSX.Element => {
  const currentTrial = () => {
    if (hasExpiredProTrial) return 'Pro'
    if (hasExpiredBusinessTrial) {
      if (isPremiumBusiness) {
        return 'Premium'
      }
      return 'Business'
    }
  }

  const titleMessage = stringTokenizer(
    translations.header,
    '{plan}',
    currentTrial(),
  )

  return (
    <Dialog open={true} onOpenChange={() => cancelTrial()}>
      <Dialog.Content size="medium">
        <div className={styles.backgroundImage} />
        <Dialog.Body>
          <Dialog.CloseButton />
          <Flex direction="column" align="center" gap="lg" fullWidth>
            <Heading size="large" align="center" className={styles.heading}>
              {titleMessage}
            </Heading>
            <Flex direction="row" gap="sm" justify="center">
              <Button variant="tertiary" onClick={() => cancelTrial()}>
                {translations.cancelTrial}
              </Button>
              <Button variant="primary" onClick={() => completeAndUpgrade()}>
                {translations.completeAndUpgrade}
              </Button>
            </Flex>
          </Flex>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  )
}

export default TrialCompleteModal
